<div class="ui-loading" v-if="isOpen">
  <div class="container">
    <svg width="60" height="60" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
      <linearGradient x1="0%" y1="100%" y2="100%" id="loading-gradient">
        <stop stop-color="currentColor" stop-opacity="0" offset="0%" />
        <stop stop-color="currentColor" stop-opacity=".5" offset="40%" />
        <stop stop-color="currentColor" offset="100%" />
      </linearGradient>
      <g fill="none" fill-rule="evenodd">
        <path d="M34 18c0-8.837-7.163-16-16-16-6.34 0-11.82 3.688-14.409 9" stroke="url(#loading-gradient)"
          stroke-width="4" stroke-linecap="round">
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 18 18" to="360 18 18"
            dur="1s" repeatCount="indefinite" />
        </path>
      </g>
    </svg>
    <div class="text-block">
      <p class="text">{{t('__common.__loading')}}</p>
    </div>
  </div>

</div>